'use client';

import React from 'react';
import type { PostCardProps } from './post-card';
import { stripMarkdown } from '@/lib/community/utils';
import { SmartCoverImage } from './smart-cover-image';
import { PostCardStats } from './post-card-stats';

export const PostCardDiscussion = React.memo(function PostCardDiscussion({ post, onClick, onTagClick, onLike, onFavorite }: PostCardProps) {
	return (
		<div
			className="liquid-glass-card rounded-md overflow-hidden cursor-pointer"
			onClick={(e) => {
				const card = e.currentTarget;
				const cover = card.querySelector('[data-cover]');
				onClick?.(post, card.getBoundingClientRect(), cover?.getBoundingClientRect() ?? undefined);
			}}
		>
			{post.coverImage && (
				<div data-cover>
					<SmartCoverImage src={post.coverImage} alt={post.title} />
				</div>
			)}

			<div className="p-3 flex flex-col gap-2">
				<h3 className="font-medium text-sm leading-snug truncate">{post.title}</h3>

				<p className="text-xs text-muted-foreground line-clamp-3 leading-relaxed">{stripMarkdown(post.description)}</p>

				{post.tags.length > 0 && (
					<div className="flex flex-wrap gap-1">
						{post.tags.slice(0, 3).map((tag) => (
							<button
								className="inline-block rounded-full bg-secondary/70 text-foreground/70 px-2 py-0.5 text-[10px] hover:text-foreground hover:bg-secondary transition-colors cursor-pointer"
								key={tag}
								onClick={(e) => {
									e.stopPropagation();
									onTagClick?.(tag);
								}}
								type="button"
							>
								#{tag}
							</button>
						))}
					</div>
				)}

				<PostCardStats onFavorite={onFavorite} onLike={onLike} post={post} />
			</div>
		</div>
	);
});
